/**
 * DESIGN.md: a centered document canvas. Before this existed, seven routes
 * rendered unbounded and three carried their own ad-hoc widths, so the page
 * title's left edge moved up to 296px between routes — the „Fișă" document
 * metaphor depends on that edge being stable.
 *
 * Width raised 1120px → 1440px on 2026-08-20 (owner request): 1120 left too much
 * empty margin on modern screens and read as cramped next to the full-width
 * Mapare views. Forms stay narrow (760px) for line-length; 'full' (dense tabular
 * review) stays uncapped.
 */
export function PageCanvas({
  width = 'document',
  children,
}: {
  width?: 'document' | 'form' | 'full';
  children: React.ReactNode;
}) {
  const maxW = width === 'form' ? 'max-w-[760px]' : width === 'full' ? 'max-w-none' : 'max-w-[1440px]';
  // 'full' (dense tabular review — see DESIGN.md) uses lighter side padding to
  // give the grid the most room; document/form keep the wider „Fișă" margins on
  // desktop but relax them on phones (px-12 alone wasted ~1/3 of a 375px screen).
  const pad = width === 'full' ? 'px-6 md:px-8' : 'px-4 sm:px-8 md:px-12';
  return <div className={`mx-auto w-full ${pad} ${maxW}`}>{children}</div>;
}
